import type { ShapeData } from '@/lib/shapes/types/shape-data'

/**
 * True when the shape being node-edited still matches its state from the moment node-edit
 * mode was entered — i.e. no node has been moved or added yet. Drives the toolbar's Reset
 * button disabled state (nothing to revert).
 */
export function nodeEditShapeUnchangedFromOriginal(
  current: ShapeData,
  original: ShapeData | null
): boolean {
  if (!original) return true

  return (
    current.path === original.path &&
    current.x === original.x &&
    current.y === original.y &&
    current.width === original.width &&
    current.height === original.height
  )
}

/**
 * True when the shape being crop-edited still matches its state from the moment crop mode was
 * entered — i.e. the frame hasn't been resized and the photo hasn't been panned/rescaled yet.
 * Drives the crop toolbar's Reset button disabled state (nothing to revert).
 */
export function cropShapeUnchangedFromOriginal(
  current: ShapeData,
  original: ShapeData | null
): boolean {
  if (!original) return true

  return (
    current.x === original.x &&
    current.y === original.y &&
    current.width === original.width &&
    current.height === original.height &&
    (current.rotation ?? 0) === (original.rotation ?? 0) &&
    current.photoFill?.offsetX === original.photoFill?.offsetX &&
    current.photoFill?.offsetY === original.photoFill?.offsetY &&
    current.photoFill?.scale === original.photoFill?.scale &&
    (current.photoFill?.rotation ?? 0) === (original.photoFill?.rotation ?? 0) &&
    !!current.photoFill?.flippedX === !!original.photoFill?.flippedX &&
    !!current.photoFill?.flippedY === !!original.photoFill?.flippedY
  )
}
